import blue from '../../assets/Markers/BluePin.png';
import gray from '../../assets/Markers/GrayPin.png';
import green from '../../assets/Markers/GreenPin.png';
import pink from '../../assets/Markers/PinkPin.png';
import lightBlue from '../../assets/Markers/LightBluePin.png';
import purple from '../../assets/Markers/PurplePin.png';
import red from '../../assets/Markers/RedPin.png';
import yellow from '../../assets/Markers/YellowPin.png';
import black from '../../assets/Markers/BlackPin.png';
import highlight from '../../assets/Markers/PinHighlight.png';

export const MARKERS: { [key: string]: string } = {
    FF62D3: pink,
    FFA500: yellow,
    FF4646: red,
    A954EC: purple,
    '858585': gray,
    '1CC328': green,
    '6FBCFF': lightBlue,
    '005BE5': blue,
    '000000': black,
    highlight: highlight,
};
